import { Link } from 'react-router'
import { ArrowLeft, Phone, Mail, User } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useContact } from '../../api/contacts'
import { formatPhone } from '../../lib/utils'

interface CallStagingHeaderProps {
  phoneNumber: string
  contactId?: number
}

export function CallStagingHeader({ phoneNumber, contactId }: CallStagingHeaderProps) {
  const { t } = useTranslation('calls')
  const { data } = useContact(contactId)
  const contact = data?.contact

  return (
    <div className="space-y-3">
      <Link
        to={contactId ? `/contacts/${contactId}` : '/'}
        className="inline-flex items-center gap-1.5 text-sm text-text-secondary hover:text-primary transition-colors"
      >
        <ArrowLeft className="h-4 w-4" />
        {contactId ? t('staging.back') : t('staging.backToDashboard')}
      </Link>

      <div className="flex flex-wrap items-center gap-4">
        {/* Avatar / Icon */}
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
          {contact ? (
            <User className="h-6 w-6 text-primary" />
          ) : (
            <Phone className="h-6 w-6 text-primary" />
          )}
        </div>

        <div className="min-w-0 flex-1">
          {contact ? (
            <>
              <h1 className="text-xl font-bold text-text-primary md:text-2xl">
                {contact.name || formatPhone(phoneNumber)}
              </h1>
              <div className="mt-1 flex flex-wrap items-center gap-3 text-sm text-text-secondary">
                <span className="inline-flex items-center gap-1 font-mono">
                  <Phone className="h-3.5 w-3.5" />
                  {formatPhone(phoneNumber)}
                </span>
                {contact.email && (
                  <span className="inline-flex items-center gap-1">
                    <Mail className="h-3.5 w-3.5" />
                    {contact.email}
                  </span>
                )}
              </div>
            </>
          ) : (
            <>
              <h1 className="text-xl font-bold text-text-primary md:text-2xl">
                {formatPhone(phoneNumber)}
              </h1>
              <p className="mt-1 text-sm text-text-secondary">{t('staging.callStaging')}</p>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
